import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useRouter } from '@tanstack/react-router';
import { AlertCircle } from '@untitledui/icons/AlertCircle';
import { ChevronLeft } from '@untitledui/icons/ChevronLeft';
import { includes } from 'lodash-es';

import { Button } from '@/components/base/buttons/button';

import { BackButton } from './back-button';

export function ProjectViewError({
  projectId,
  errors,
}: {
  projectId: string;
  errors?: string[];
}) {
  const router = useRouter();

  const isAccessError = includes(errors, 'PRIVATE_USER_MARKETPLACE');
  const isProjectNotReadyError = includes(errors, 'PROJECT_NOT_PAID');

  const errorMessage = isAccessError
    ? t`You are not authorized to access this project.`
    : isProjectNotReadyError
      ? t`This project is not ready to be applied to.`
      : t`Something went wrong while loading this project. Please try again later.`;

  return (
    <div className="mx-auto max-w-[var(--max-width-container)] px-4 pt-6 pb-18 md:px-8">
      <div className="mb-6">
        <BackButton projectId={projectId} />
      </div>
      <div className="flex flex-col items-center py-16 text-center">
        <AlertCircle className="mb-4 size-12 text-fg-quaternary" />
        <h1 className="mb-2 font-heading text-xl font-semibold text-primary">
          <Trans>Unable to access project</Trans>
        </h1>
        <p className="mb-6 text-secondary">{errorMessage}</p>
        <Button
          onClick={() => router.navigate({ to: '/participants/projects' })}
          iconLeading={ChevronLeft}
          color="primary"
          size="sm"
        >
          <Trans>Browse more projects</Trans>
        </Button>
      </div>
    </div>
  );
}
